import apiHelper from "../../../services/apiHelper";
import {BookingEvent, EventAvailability, Booking} from "../models/BookingEvent";
import Addon from "../../addon/models/Addon";

const BookingService = {
  getEventWithSlots: (basePath = '/booking/crunchone') => {
    return apiHelper.fetch(`${basePath}/event`)
      .then(response => response.json())
      .then(data => {
        return {
          event: new BookingEvent(data.event),
          availability: data.availability.map(item => new EventAvailability(item)),
          addon: data.addon ? new Addon(data.addon) : null,
          booking: data.booking ? new Booking(data.booking) : null,
          trainerDayDate: data.trainer_day_date || '',
          isPtClient: data.is_pt_client === true,
          ptPromoActive: data.pt_promo_active === true,
          ptPromoEnabled: data.pt_promo_enabled === true,
        };
      });
  },
  bookEvent: (event_id, slot, addon, payment, focusArea = null, basePath = '/booking/crunchone') => {
    const data = {
      event_id: event_id,
      start_date_time: slot ? slot.getSlotStart() : null,
      credit_card: payment,
      addon: addon
    };
    if (focusArea) {
      data.focus_area = focusArea;
    }

    return apiHelper.fetch(`${basePath}/book_event`, {
      body: data,
      method: 'POST',
    }).then(response => response.json())
  }
};

export default BookingService;